const addOutgoingParamsToRedirectURL = (
  redirectURLString,
  token,
  oAuthStateParameter,
  clientID,
  responseType,
  userID
) => {
  const redirectURL = new URL(redirectURLString)

  if (oAuthStateParameter) {
    redirectURL.searchParams.append('state', oAuthStateParameter)
  }

  if (responseType === 'code') {
    redirectURL.searchParams.append('code', userID)
  } else {
    redirectURL.searchParams.append('access_token', token)
    redirectURL.searchParams.append('token_type', 'bearer')
  }

  if (clientID === 'ANOVA_GOOGLE_HOME') {
    const redirectURLWithHashParams = convertURLSearchParamsToHashParams(redirectURL)
    redirectURLWithHashParams.searchParams.delete('state')
    redirectURLWithHashParams.searchParams.delete('access_token')
    redirectURLWithHashParams.searchParams.delete('token_type')
    return redirectURLWithHashParams.href
  }

  return redirectURL.href
}

const convertURLSearchParamsToHashParams = (redirectURL) => {
  redirectURL.hash = redirectURL.searchParams.toString()

  return redirectURL
}

export default addOutgoingParamsToRedirectURL
